import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { EcomItemCartCheckoutComponent } from './ecom-item-cart-checkout.component';

@Injectable()
export class CheckoutCanDeactivateGaurdService implements CanDeactivate<EcomItemCartCheckoutComponent> {
    constructor() { }

    canDeactivate(component: EcomItemCartCheckoutComponent): boolean {
        if (component.clickEvent === 'BACK' && component.checkoutform.dirty) {
            return confirm('Are you sure to cancel the action?');
        }
        return true;
    }
}
